import {MapNode, DisconnectedMapNode} from 'common/src/modules/nodes/nodes.types';

/**
 * Converts a connected map node to a disconnected map node.
 * @param node - The connected map node to convert.
 * @returns The disconnected map node.
 */
export default function toDisconnectedMapNode(node: MapNode): DisconnectedMapNode {
  return {
    ...node,
    inputs: node.inputs.map((input) => ({
      nodeId: input.node?.id ?? null,
      outputIdx: input.outputIdx,
    })),
    outputs: node.outputs.map((output) => ({
      nodeId: output.nodeId,
      referencedNodeId: output.node?.id ?? null,
      receivedContent: output.receivedContent,
      id: output.id,
      type: output.type,
      name: output.name,
    })),
  };
}
